import { Controller } from '@hotwired/stimulus';

const Opening = (job) => {
    const {
        id,
        title,
        location = {},
        departments,
        content = '',
    } = job;

    delete job.content;

    const [ department = {} ] = departments;

    return `
        <div class='job-card' data-controller='job-card-controller' id='job-${ id }'
            data-job-card-controller-job-value='${ JSON.stringify(job) }'
            data-job-card-controller-content-value='${content}'
            tabIndex='0'
            data-action='click->job-card-controller#dispatch'
        >
            <h2 class='job-card-title'>${ title }</h2>
            <p class='job-card-location'>${ location.name || 'No location'}.</p>
            <div class='job-card-tags'>
                <div class='job-card-tag department'>${ department.name || 'No department'}</div>
            </div>
        </div>
    `;
};

export default class extends Controller {
    constructor(props) {
        super(props);
        this.boardURl = 'https://boards-api.greenhouse.io/v1/boards/shipbobinc/jobs?content=true';
    }

    static get values() {
        return {
            openings: Object,
            filters: Object,
            activeFilters: Object,
        }
    }

    static get targets() {
        return [
            'jobs',
            'filters',
        ];
    }

    connect() {
        this.element.setAttribute('id', 'positions');
        this.element.setAttribute('tabIndex', '0');
        this.jobsTarget.classList.add('container');

        this.fetchData();
    }

    fetchData() {
        fetch(this.boardURl).then((resp) => resp.json())
            .then((jobs) => {
                this.originalsValiue = jobs;

                return this.openingsValue = jobs;
            });
    }

    async generateFilterOptions(jobs) {
        const filters = jobs.reduce((total, current) => {
            if(!current) {
                return total;
            }

            const {
                location = {},
                departments,
            } = current;

            const [ department = {} ] = departments;

            const {
                job_locations = [],
                job_departments = [],
            } = total

            return {
                job_locations: [ ...job_locations, location.name ],
                job_departments: [ ...job_departments, department.name ],
            }

        }, {});

        this.filtersValue = {
            locations: [...new Set(filters.job_locations)],
            departments:[...new Set(filters.job_departments)],
        };

        return jobs;
    }

    async generateCards(jobs) {
        if(!jobs) {
            return null;
        }

        const { locations, departments } = this.activeFiltersValue;

        return jobs.reduce((total, current) => {
            if (!current)  {
                return total;
            }

            switch(true) {
                case !locations.length && !departments.length:
                case locations.includes(current.location.name):
                case departments.includes(current.departments[0].name):
                    const card = Opening(current);
                    return total + card;
                default:
                    return total;
            }
        }, '');
    }

    async updateCards(html) {
        this.jobsTarget.innerHTML = html;
    }

    async updateVisiblePositions(jobs) {
        this.jobsTarget.innerHTML = '';

        return this.generateCards(jobs)
            .then((html) => this.updateCards(html));
    }

    openingsValueChanged() {
        if (!this.openingsValue.jobs) {
            return null;
        }

        this.generateFilterOptions(this.openingsValue['jobs'])
    }

    generateFilterID(name = '', type) {

        const id = (name.replaceAll(' ', '-')).toLowerCase();
        return `${type}-${id}`;
    }

    renderFilterUI() {
        const { locations, departments } = this.filtersValue;

        const Header = `<div class='filter-controls'>
            <h4 class='filter-controls-header'>Filters</h4>
            <button class='btn btn-secondary' data-action='greenhouse-controller#resetFilters'>Reset</button>
        </div>`

        const FilterElement = (name, type) => {
            if (!name) {
                return null;
            }

            return(`
                <div class='filter-checkbox' id='${this.generateFilterID(name, type)}'>
                    <input class='filter-checkbox-input' type='checkbox' name=${name} data-action="greenhouse-controller#updateActiveFilter" data-greenhouse-controller-payload-param='{"filter":"${name}", "type": "${type}"}'>
                    <label class='filter-checkbox-label'>${name}</label>
                </div>`
            )};

        const Group = (items, type) => {
            return (
                `<fieldset class='filter-groupset'>
                    <label class='filter-title'>${type}</label>
                    ${(items.map((item) => FilterElement(item, type))).join('')}
                </fieldset>`
            );
        };

        const LocationFilters = Group(locations, 'locations');
        const DepartmentFilters = Group(departments, 'departments');

        this.filtersTarget.innerHTML = Header + DepartmentFilters + LocationFilters;
    }

    updateActiveFilter(event) {
        const {
            target: {
                checked,
            },
            params: {
                payload,
            },
        } = event;

        const {
            type,
            filter,
        } = payload;

        if (!checked) {
            this.removeFilter(type, filter);
        } else {
            this.addFilter(type, filter);
        }
    }


    addFilter(type, filter) {
        const current = this.activeFiltersValue[type];
        const activeFilters = this.activeFiltersValue;

        const element = document.getElementById(this.generateFilterID(filter, type));
        element.classList.add('active');

        this.activeFiltersValue = {
            ...activeFilters,
            [type]: [ ...current, filter ],
        }
    }

    removeFilter(type, filter) {
        let current =  this.activeFiltersValue[type];
        const activeFilters = this.activeFiltersValue;
        current = current.filter((item) => (item !== filter));

        const element = document.getElementById(this.generateFilterID(filter, type));
        element.classList.remove('active');

        this.activeFiltersValue  = {
            ...activeFilters,
            [type]: [ ...current ],
        }
    }

    filtersValueChanged() {
        if(!this.filtersValue.locations || !this.filtersValue.departments) {
            return null;
        }

        this.resetFilters();
    }

    resetFilters() {
        this.filtersTarget.innerHTML = '';
        this.renderFilterUI();
        this.activeFiltersValue = { locations: new Array(), departments: new Array() };
    }

    activeFiltersValueChanged() {
        if (!this.activeFiltersValue || this.activeFiltersValue === {}) {
            return null;
        }

        this.updateVisiblePositions(this.openingsValue['jobs']);
    }
}
